module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swipe-container",
    class: {
      'external-dots': _vm.externalDots
    }
  }, [_c('div', {
    staticClass: "slides",
    attrs: {
      "id": "slides"
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "slider-dots"
  }, _vm._l((_vm.slides), function(i) {
    return _c('div', {
      staticClass: "dot-container",
      on: {
        "click": function($event) {
          return _vm.changeSlide(i - 1)
        }
      }
    }, [_c('div', {
      staticClass: "dot",
      class: {
        'selected': _vm.selectedDot === i - 1
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43467892","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_slider.vue
// module id = 374
// module chunks = 1